import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Typography, Paper } from '@mui/material';
import { ScreenFrame } from '../PrototypeShared';

export default function HelpScreen() {
  return (
    <ScreenFrame
      title="Help"
      actions={<Button component={Link} to="/prototype/dashboard" variant="outlined" size="small">Dashboard</Button>}
    >
      <Typography color="text.secondary" paragraph>User manual and FAQ. All links below are clickable.</Typography>
      <Paper sx={{ p: 2 }}>
        <Button component={Link} to="/prototype/incoming-deliveries" sx={{ display: 'block', textAlign: 'left' }}>Incoming deliveries</Button>
        <Button component={Link} to="/prototype/audits" sx={{ display: 'block', textAlign: 'left' }}>Audits</Button>
        <Button component={Link} to="/prototype/processes" sx={{ display: 'block', textAlign: 'left' }}>Processes</Button>
      </Paper>
    </ScreenFrame>
  );
}
